import { useSelector, /* useDispatch  */ } from 'react-redux'
import { Row } from "react-bootstrap";
import { useState, /* useRef, */ useEffect } from 'react';
import { /* Button, Input, Space, */ Table, Form,/*  InputNumber, */ Empty } from 'antd';
// import { getStyle } from '../../libs/todoSlice'
import { getHistoryDetail } from '../../../../libs/historySlice';
const MophCaregiverHistoryDetailSuccess = () => {
    const details = useSelector(getHistoryDetail)
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [objective, setObjective] = useState([]);
    useEffect(() => {
        

        setObjective(details.importHistories[details.importHistories.length - 1].objective)
        setData(details.importHistories[details.importHistories.length - 1].successDetail.map((items, index) => {
            return {
                index: index + 1,
                loading: false,
                address: items.request.address,
                sub_district: items.request.sub_district,
                district: items.request.district,
                province: items.request.province,
                zipcode: items.request.zipcode,
                idCardType: items.request.idCardType ? items.request.idCardType : items.request.id_card_type,
                idCardNum: items.request.id_card_num,
                mobileNO: items.request.mobile_no,
                employeeID: items.request.employeeID ? items.request.employeeID : items.request.employee_id,
                position_1: items.request.position_1,
                position_2: items.request.position_2,
                position_3: items.request.position_3,
                position_4: items.request.position_4,
                name_th: (items.request.title_th ? items.request.title_th : items.request.account_title_th ? items.request.account_title_th : '') + " " +
                    (items.request.first_name_th ? items.request.first_name_th : '') + " " +
                    (items.request.last_name_th ? items.request.last_name_th : ''),
                name_eng: (items.request.title_en ? items.request.title_en : items.request.account_title_eng ? items.request.account_title_eng : '') + " " +
                    (items.request.first_name_eng ? items.request.first_name_eng : '') + " " +
                    (items.request.last_name_eng ? items.request.last_name_eng : ''),

            }
        }))
    }, [])

    const customLocale = {
        emptyText: (<Empty
            description="ไม่มีข้อมูล"
        />)
    };
    const columns = [
        {
            title: 'ลำดับ',
            width: 70,
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: (
                <div>
                    ชื่อ - นามสกุล <br />(ภาษาไทย)
                </div>
            ),
            dataIndex: 'name_th',
            key: 'name_th',
            show: true,
            width: 150,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: (
                <div>
                    ชื่อ - นามสกุล <br />(ภาษาอังกฤษ)
                </div>
            ),
            dataIndex: 'name_eng',
            key: 'name_eng',
            show: true,
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'ประเภทบัตร',
            dataIndex: 'idCardType',
            key: 'idCardType',
            show: true,
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'เลขบัตรประชาชน',
            dataIndex: 'idCardNum',
            key: 'idCardNum',
            show: true,
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'รหัสพนักงาน',
            dataIndex: 'employeeID',
            key: 'employeeID',
            show: true,
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],

        },
        {
            title: 'เบอร์โทร',
            dataIndex: 'mobileNO',
            key: 'mobileNO',
            show: true,
            width: 150,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],

        },
        {
            title: 'ที่อยู่',
            dataIndex: 'address',
            key: 'address',
            show: true,
            width: 250,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },

        {
            title: 'ตำบล',
            dataIndex: 'sub_district',
            key: 'sub_district',
            show: true,
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'อำเภอ',
            dataIndex: 'district',
            key: 'district',
            show: true,
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'จังหวัด',
            dataIndex: 'province',
            key: 'province',
            show: true,
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'รหัสไปรษณีย์',
            dataIndex: 'zipcode',
            key: 'zipcode',
            show: true,
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
    ].filter(head => head.show);
    return (
        <Row>
            {/* ui table */}
            <Form form={form} component={false}>
                <Table
                    locale={customLocale}
                    bordered
                    dataSource={data}
                    columns={columns}
                    rowClassName="editable-row"
                    agination={{ pageSize: 25, }}
                    scroll={{
                        x: 1400,
                        y: 400,
                    }}

                />
            </Form>
            {/* end ui table */}
        </Row>
    )
}
export default MophCaregiverHistoryDetailSuccess